import { createFileRoute } from "@tanstack/react-router";
import { Require } from "../features/require";
import { TablesPage } from "../features/tables/tables-page";

export const Route = createFileRoute("/more/tables")({ component: Page });

function Page() {
	return (
		<Require permission="tables.manage">
			<TablesPage />
		</Require>
	);
}
